import React, { useEffect } from 'react';
import Header from '../components/Layout/Header';
import AgentCard from '../components/Agent/AgentCard';
import { useAgentStore } from '../store/useAgentStore';
import { agentService } from '../services/api';
import toast from 'react-hot-toast';

const AgentsPage: React.FC = () => {
  const { agents, setAgents } = useAgentStore();
  const [stats, setStats] = React.useState({
    total: 0,
    active: 0,
    custom: 0,
  });

  useEffect(() => {
    loadAgents();
  }, []);

  useEffect(() => {
    setStats({
      total: agents.length,
      active: agents.filter(a => a.isActive).length,
      custom: agents.filter(a => !a.isSystemAgent).length,
    });
  }, [agents]);

  const loadAgents = async () => {
    try {
      const data = await agentService.getAll();
      setAgents(data);
    } catch (error) {
      toast.error('Failed to load agents');
    }
  };

  return (
    <div className="flex flex-col h-screen">
      <Header 
        title="Agent Management" 
        subtitle="View and manage all available agents"
      />

      <div className="flex-1 overflow-y-auto p-8">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-gradient-to-br from-primary to-secondary text-white rounded-xl p-6 text-center">
            <div className="text-4xl font-bold mb-2">{stats.total}</div>
            <div className="text-sm opacity-90">Total Agents</div>
          </div>
          <div className="bg-gradient-to-br from-primary to-secondary text-white rounded-xl p-6 text-center">
            <div className="text-4xl font-bold mb-2">{stats.active}</div>
            <div className="text-sm opacity-90">Active Agents</div>
          </div>
          <div className="bg-gradient-to-br from-primary to-secondary text-white rounded-xl p-6 text-center">
            <div className="text-4xl font-bold mb-2">{stats.custom}</div>
            <div className="text-sm opacity-90">Custom Agents</div>
          </div>
        </div>

        {/* Agents List */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-900">🤖 All Agents</h3>
            <button
              onClick={loadAgents}
              className="px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-lg font-semibold hover:shadow-lg transition-all"
            >
              🔄 Refresh
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {agents.map((agent) => (
              <div key={agent.id} className="relative">
                <AgentCard agent={agent} />
                <div className="mt-2 flex gap-2">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    agent.isActive 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {agent.isActive ? '✓ Active' : '✗ Inactive'}
                  </span>
                  {agent.isSystemAgent && (
                    <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                      System Agent
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentsPage;
